import { AuthLibSecurity } from '@eventbrite/auth-lib';
import { setWindowLocation } from '@eventbrite/http';

export const submitSuccessRedirect = (url: string) => () => {
    const _url = AuthLibSecurity.sanitizeRedirectUrl(url);

    return setWindowLocation(_url);
};
